import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Platform from "./pages/Platform";
import ForEmployees from "./pages/ForEmployees";
import ForOrganizations from "./pages/ForOrganizations";
import ForWork from "./pages/ForWork";
import About from "./pages/About";

// Lazy-loaded so the markdown libraries (react-markdown, gray-matter) and
// post content are only downloaded when the user actually visits /blog —
// the rest of the site pays zero cost for the blog.
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));

function App() {
  return (
    <Router>
      <Suspense fallback={<p style={{ padding: "4rem", textAlign: "center" }}>Loading…</p>}>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/platform" element={<Platform />} />
        <Route path="/for-employees" element={<ForEmployees />} />
        <Route path="/for-organizations" element={<ForOrganizations />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
      </Routes>
    </Suspense>
  </Router>
  );
}

export default App;